import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServiceReply } from "userful-chronos-app-common-js/dist/models/common";
import { HttpsSettings } from "userful-chronos-app-common-js/dist/models/config/httpsSettings";
import { AppStatus } from "userful-chronos-app-common-js/dist/models/postLoginData";
import {
    applyHttpsSettingsToServer,
    getHttpsErrors,
    HttpsSettingsError,
    initHttpsSettings,
    sanitizeHttpsSettings,
} from "./httpsUtils";

const initialState: {
    initialSettings: HttpsSettings;
    popUpError: string;
    settings: HttpsSettings;
    errors: HttpsSettingsError;
    setupError: ServiceReply<any>;
    defaultSSHUserEnable: boolean;
} = {
    initialSettings: { ...initHttpsSettings() },
    popUpError: "",
    settings: { ...initHttpsSettings() },
    errors: {},
    setupError: null,
    defaultSSHUserEnable: false,
};

export const httpsSlice = createSlice({
    name: "httpsSlice",
    initialState,
    reducers: {
        initSettings: (state, action: PayloadAction<AppStatus | null>) => {
            const initSetts = initHttpsSettings(action.payload);
            state.settings = { ...initSetts };
            state.initialSettings = { ...initSetts };
            state.errors = getHttpsErrors(initSetts);
            state.defaultSSHUserEnable = action.payload ? action.payload.defaultSSHUserEnable : false;
        },
        updateSettings: (state, action: PayloadAction<Partial<HttpsSettings>>) => {
            state.settings = {
                ...state.settings,
                ...action.payload,
            };
            state.errors = getHttpsErrors(state.settings);
        },
        sanitizeSettings: (state) => {
            state.settings = sanitizeHttpsSettings(state.settings);
            state.errors = getHttpsErrors(state.settings);
        },
        toggleAutoGenerateCert: (state) => {
            state.settings = {
                ...state.settings,
                selfSigned: !state.settings.selfSigned,
            };
        },
        applySettingsToServer: (state, action: PayloadAction<string>) => {
            state.settings = sanitizeHttpsSettings(state.settings);
            state.errors = getHttpsErrors(state.settings);
            if (state.errors.cert || state.errors.frontEndUrl || state.errors.key) {
                // console.log("Https settings has errors");
                return;
            }

            const response = applyHttpsSettingsToServer(state.settings, action.payload);

            console.debug(response);

            if (response) {
                state.popUpError = response.unlocalizedMsg;
            }
        },
        clearErrors: (state) => {
            state.errors = {};
            state.setupError = null;
        },
        clearPopUpError: (state) => {
            state.popUpError = "";
        },
    },
});

export const httpsActions = httpsSlice.actions;

export default httpsSlice.reducer;
